document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Vars
   *******************************/
  const body = document.querySelector('body');
  const screenWidth = window.innerWidth;

  /********************************
   * Footer
   *******************************/
  const footer = document.querySelector('.custom-footer');

  if (footer) {
    const accordionTrigger = footer.querySelector('[data-accordion-trigger]');
    const accordionContent = footer.querySelector('[data-accordion-content]');
    const iconPlus = footer.querySelector('.icon-plus');
    const langBtn = footer.querySelector('.localization-btn');
    const langList = footer.querySelector('.localization-list');
    const langForm = footer.querySelector('#FooterLanguageForm');
    const langInput = langForm ? langForm.querySelector('input[name="locale_code"]') : null;
    const scrollTopBtn = footer.querySelector('.scroll-top');

    if (accordionTrigger && accordionContent) {
      accordionTrigger.addEventListener('click', () => {
        if (window.innerWidth > 768) return;

        const isOpen = accordionContent.classList.contains('is-open');
        accordionContent.classList.toggle('is-open', !isOpen);
        accordionTrigger.setAttribute('aria-expanded', String(!isOpen));

        if (iconPlus) {
          iconPlus.textContent = isOpen ? '+' : '-';
        }
      });
    }

    if (langBtn && langList && langForm && langInput) {
      langBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = langList.getAttribute('data-open') === 'true';
        langList.setAttribute('data-open', String(!isOpen));
        langBtn.setAttribute('aria-expanded', String(!isOpen));
      });

      document.addEventListener('click', (e) => {
        if (!langBtn.contains(e.target) && !langList.contains(e.target)) {
          langList.setAttribute('data-open', 'false');
          langBtn.setAttribute('aria-expanded', 'false');
        }
      });

      langList.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          langInput.value = link.getAttribute('data-value');
          langForm.submit();
        });
      });
    }

    if (scrollTopBtn) {
      scrollTopBtn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  /********************************
   * Unboxed reviews
   *******************************/
  const unboxedSections = document.querySelectorAll('[data-unboxed-reviews]');

  if (unboxedSections.length) {
    unboxedSections.forEach((section) => {
      const viewport = section.querySelector('[data-unboxed-viewport]');
      const track = section.querySelector('[data-unboxed-track]');
      const cards = [...section.querySelectorAll('[data-unboxed-card]')];
      const prevBtn = section.querySelector('[data-unboxed-prev]');
      const nextBtn = section.querySelector('[data-unboxed-next]');
      const dotsWrap = section.querySelector('[data-unboxed-dots]');
      const nav = section.querySelector('.nav');

      if (!viewport || !track || !cards.length) return;

      let pageCount = 1;
      let currentPage = 0;

      const getGap = () => {
        const styles = window.getComputedStyle(track);
        const gapValue = styles.columnGap !== 'normal' ? styles.columnGap : styles.gap;
        const parsed = parseFloat(gapValue);
        return Number.isFinite(parsed) ? parsed : 0;
      };

      const getStep = () => {
        const rect = cards[0].getBoundingClientRect();
        return rect.width + getGap();
      };

      const needsSlider = () => {
        return track.scrollWidth > viewport.clientWidth + 2;
      };

      const getVisibleCount = () => {
        const step = getStep();
        if (!step) return 1;
        return Math.max(1, Math.floor((viewport.clientWidth + getGap()) / step));
      };

      const getPageCount = () => {
        if (!needsSlider()) return 1;
        return Math.max(1, cards.length - getVisibleCount() + 1);
      };

      const getPageFromScroll = () => {
        const step = getStep();
        if (!step) return 0;
        return Math.max(0, Math.min(pageCount - 1, Math.round(track.scrollLeft / step)));
      };

      const updateControls = () => {
        const sliderActive = needsSlider();
        section.classList.toggle('--is-slider', sliderActive);

        if (nav) nav.hidden = !sliderActive;
        if (dotsWrap) dotsWrap.hidden = !sliderActive || pageCount <= 1;

        if (!sliderActive) {
          track.scrollLeft = 0;
          currentPage = 0;
          if (prevBtn) prevBtn.disabled = true;
          if (nextBtn) nextBtn.disabled = true;
          return;
        }

        if (prevBtn) prevBtn.disabled = currentPage <= 0;
        if (nextBtn) nextBtn.disabled = currentPage >= pageCount - 1;

        if (dotsWrap) {
          dotsWrap.querySelectorAll('.dot').forEach((dot, i) => {
            dot.classList.toggle('--active', i === currentPage);
          });
        }
      };

      const goTo = (page) => {
        if (!needsSlider()) return;
        currentPage = Math.max(0, Math.min(page, pageCount - 1));
        track.scrollTo({ left: currentPage * getStep(), behavior: 'smooth' });
        updateControls();
      };

      const renderDots = () => {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';

        if (!needsSlider() || pageCount <= 1) {
          dotsWrap.hidden = true;
          return;
        }

        dotsWrap.hidden = false;
        for (let i = 0; i < pageCount; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'dot' + (i === currentPage ? ' --active' : '');
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => goTo(i));
          dotsWrap.appendChild(dot);
        }
      };

      const syncFromScroll = () => {
        if (!needsSlider()) {
          updateControls();
          return;
        }
        currentPage = getPageFromScroll();
        updateControls();
      };

      const refresh = () => {
        pageCount = getPageCount();
        currentPage = Math.min(currentPage, pageCount - 1);
        renderDots();
        updateControls();
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          goTo(currentPage - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          goTo(currentPage + 1);
        });
      }

      let scrollTimer;
      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(syncFromScroll, 50);
      }, { passive: true });

      refresh();
      window.addEventListener('resize', refresh);

      section.querySelectorAll('[data-unboxed-media]').forEach((media) => {
        const video = media.querySelector('video');
        const playBtn = media.querySelector('[data-unboxed-play]');
        if (!video || !playBtn) return;

        const pauseOthers = () => {
          section.querySelectorAll('[data-unboxed-media] video').forEach((other) => {
            if (other === video) return;
            other.pause();
            const otherMedia = other.closest('[data-unboxed-media]');
            if (otherMedia) otherMedia.classList.remove('--playing');
          });
        };

        const playVideo = () => {
          pauseOthers();
          video.muted = false;
          const playPromise = video.play();
          media.classList.add('--playing');
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
              video.muted = true;
              video.play().catch(() => {});
            });
          }
        };

        const pauseVideo = () => {
          video.pause();
          media.classList.remove('--playing');
        };

        playBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) playVideo();
          else pauseVideo();
        });

        video.addEventListener('click', () => {
          if (video.paused) playVideo();
          else pauseVideo();
        });

        video.addEventListener('ended', () => {
          media.classList.remove('--playing');
        });
      });
    });
  }

  /********************************
   * FAQ
   *******************************/
  const faqSections = document.querySelectorAll('[data-faq]');

  if (faqSections.length) {
    faqSections.forEach((section) => {
      const items = [...section.querySelectorAll('[data-faq-item]')];
      if (!items.length) return;

      const closeItem = (item) => {
        const trigger = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');
        if (!panel || !item.classList.contains('--open')) return;

        item.classList.remove('--open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');

        panel.hidden = false;
        panel.style.height = `${panel.scrollHeight}px`;
        panel.offsetHeight;
        panel.style.height = '0px';

        const onEnd = (event) => {
          if (event.target !== panel || event.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          panel.hidden = true;
          panel.style.height = '';
        };

        panel.addEventListener('transitionend', onEnd);
      };

      const openItem = (item) => {
        const trigger = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');
        if (!panel || item.classList.contains('--open')) return;

        items.forEach((other) => {
          if (other !== item) closeItem(other);
        });

        item.classList.add('--open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');

        panel.hidden = false;
        panel.style.height = '0px';
        panel.offsetHeight;
        panel.style.height = `${panel.scrollHeight}px`;

        const onEnd = (event) => {
          if (event.target !== panel || event.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          panel.style.height = 'auto';
        };

        panel.addEventListener('transitionend', onEnd);
      };

      items.forEach((item) => {
        const trigger = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');
        if (!trigger) return;

        if (item.classList.contains('--open') && panel) {
          panel.hidden = false;
          panel.style.height = 'auto';
        } else if (panel) {
          panel.hidden = true;
          panel.style.height = '0px';
        }

        trigger.addEventListener('click', () => {
          if (item.classList.contains('--open')) closeItem(item);
          else openItem(item);
        });
      });
    });
  }

  /********************************
   * Announcement bar
   *******************************/
  const announcementSections = document.querySelectorAll('[data-announcement-slider]');

  if (announcementSections.length) {
    announcementSections.forEach((section) => {
      const track = section.querySelector('[data-announcement-track]');
      const slides = [...section.querySelectorAll('[data-announcement-slide]')];
      const prevBtn = section.querySelector('[data-announcement-prev]');
      const nextBtn = section.querySelector('[data-announcement-next]');

      if (!track || slides.length < 2) return;

      let index = 0;

      const goTo = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          goTo(index - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          goTo(index + 1);
        });
      }
    });
  }
});
